<template>
  <div class="spu-list">
    <el-card>
      <div slot="header" class="card-header">
        <div class="header-left">
          <span>SPU管理</span>
          <el-tag v-if="pid" type="info" closable @click="clearPidFilter" style="margin-left: 10px;">
            <i class="el-icon-goods" style="margin-right: 5px;"></i>
            商品: {{ productName }}
          </el-tag>
        </div>
        <el-button type="primary" size="small" @click="handleAdd">新增SPU</el-button>
      </div>
      <el-table :data="tableData" border stripe v-loading="loading" style="cursor: pointer;">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="spuId" label="SPU ID" width="150"></el-table-column>
        <el-table-column label="商品信息" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.product">{{ scope.row.product.productName }}</span>
            <span v-else style="color: #909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌信息" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.brand" size="small">{{ scope.row.brand.shortName || scope.row.brand.nameCn }}</el-tag>
            <span v-else style="color: #909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="color" label="颜色" width="100"></el-table-column>
        <el-table-column prop="size" label="尺码" width="100"></el-table-column>
        <el-table-column label="总库存" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.totalStock <= 10" type="danger">{{ scope.row.totalStock }}</el-tag>
            <el-tag v-else-if="scope.row.totalStock <= 50" type="warning">{{ scope.row.totalStock }}</el-tag>
            <el-tag v-else type="success">{{ scope.row.totalStock }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.stop="handleManageSku(scope.row)">SKU管理</el-button>
            <el-button type="text" size="small" @click.stop="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click.stop="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <el-dialog :title="spuDialogTitle" :visible.sync="spuDialogVisible" width="600px">
      <el-form :model="spuForm" :rules="spuRules" ref="spuForm" label-width="100px">
        <el-form-item label="商品" prop="pid">
          <el-select v-model="spuForm.pid" placeholder="请选择商品" style="width: 100%;" :disabled="isEdit" clearable filterable>
            <el-option
              v-for="product in allProducts"
              :key="product.pid"
              :label="product.productName"
              :value="product.pid"
            >
              <span>{{ product.productName }}</span>
              <span v-if="product.brand" style="float: right; color: #8492a6; font-size: 13px">{{ product.brand.shortName || product.brand.nameCn }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颜色" prop="color">
          <el-input v-model="spuForm.color" placeholder="请输入颜色"></el-input>
        </el-form-item>
        <el-form-item label="尺码" prop="size">
          <el-input v-model="spuForm.size" placeholder="请输入尺码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="spuDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSpuSubmit" :loading="spuSubmitLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
        </el-table-column>
        <el-table-column label="品牌信息" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.brand" size="small">{{ scope.row.brand.shortName || scope.row.brand.nameCn }}</el-tag>
            <span v-else style="color: #909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="color" label="颜色" width="100"></el-table-column>
        <el-table-column prop="size" label="尺码" width="100"></el-table-column>
        <el-table-column label="总库存" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.totalStock <= 10" type="danger">{{ scope.row.totalStock }}</el-tag>
            <el-tag v-else-if="scope.row.totalStock <= 50" type="warning">{{ scope.row.totalStock }}</el-tag>
            <el-tag v-else type="success">{{ scope.row.totalStock }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.stop="handleManageSku(scope.row)">SKU管理</el-button>
            <el-button type="text" size="small" @click.stop="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click.stop="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <el-dialog :title="spuDialogTitle" :visible.sync="spuDialogVisible" width="600px">
      <el-form :model="spuForm" :rules="spuRules" ref="spuForm" label-width="100px">
        <el-form-item label="商品PID" prop="pid">
          <el-input v-model="spuForm.pid" placeholder="请输入商品PID"></el-input>
        </el-form-item>
        <el-form-item label="颜色" prop="color">
          <el-input v-model="spuForm.color" placeholder="请输入颜色"></el-input>
        </el-form-item>
        <el-form-item label="尺码" prop="size">
          <el-input v-model="spuForm.size" placeholder="请输入尺码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="spuDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSpuSubmit" :loading="spuSubmitLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SpuManage',
  data() {
    return {
      tableData: [],
      total: 0,
      loading: false,
      query: {
        pid: null,
        pageNum: 1,
        pageSize: 10
      },
      pid: null,
      productName: '',
      spuDialogVisible: false,
      spuDialogTitle: '',
      spuForm: {
        id: null,
        spuId: '',
        pid: '',
        color: '',
        size: ''
      },
      isEdit: false,
      allProducts: [],
      spuRules: {
        pid: [{ required: true, message: '请选择商品', trigger: 'change' }],
        color: [{ required: true, message: '请输入颜色', trigger: 'blur' }],
        size: [{ required: true, message: '请输入尺码', trigger: 'blur' }]
      },
      spuSubmitLoading: false
    }
  },
  async mounted() {
    // 检查路由参数
    if (this.$route.query.pid) {
      this.pid = this.$route.query.pid
      this.productName = this.$route.query.productName || ''
      this.query.pid = this.pid
    }
    await this.loadData()
    await this.loadProducts()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          pageNum: this.query.pageNum,
          pageSize: this.query.pageSize
        }
        if (this.pid) {
          params.pid = this.pid
        }
        const res = await this.$http.get('/spu/page', { params })
        let data = res
        if (res.data && res.data.code === 200) {
          data = res.data
        } else if (res.code === '200' || res.code === 200) {
          data = res
        }
        if (data.code === '200' || data.code === 200) {
          if (data.data && data.data.records) {
            this.tableData = data.data.records
            this.total = data.data.total
          } else if (data.data) {
            this.tableData = data.data.list || data.data || []
            this.total = data.data.total || 0
          } else {
            this.tableData = []
            this.total = 0
          }
        }
      } catch (error) {
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    async loadProducts() {
      try {
        // 先获取所有商品，不分页
        const res = await this.$http.get('/productNew/page', { params: { pageNum: 1, pageSize: 1000 } })
        if (res.code === '200' || res.code === 200) {
          this.allProducts = res.data.list || res.data.records || []
        } else if (res.data && (res.data.code === '200' || res.data.code === 200)) {
          this.allProducts = res.data.data.list || res.data.data.records || []
        }
      } catch (error) {
        console.error('加载商品列表失败', error)
      }
    },
    clearPidFilter() {
      this.pid = null
      this.productName = ''
      this.query.pid = null
      this.$router.replace({ query: {} })
      this.loadData()
    },
    handleAdd() {
      this.spuDialogTitle = '新增SPU'
      this.spuForm = { id: null, spuId: '', pid: this.pid || '', color: '', size: '' }
      this.isEdit = false
      this.spuDialogVisible = true
    },
    handleEdit(row) {
      this.spuDialogTitle = '编辑SPU'
      this.spuForm = { id: row.id, spuId: row.spuId, pid: row.pid, color: row.color, size: row.size }
      this.isEdit = true
      this.spuDialogVisible = true
    },
    async handleDelete(row) {
      this.$confirm('确定要删除该SPU吗？关联的SKU也将被删除。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$http.delete(`/spu/${row.id}`)
          let success = false
          let message = '删除失败'
          if (res.code === '200' || res.code === 200) {
            success = true
          } else if (res.data && (res.data.code === '200' || res.data.code === 200)) {
            success = true
          }
          if (res.message) message = res.message
          if (res.data && res.data.message) message = res.data.message
          
          if (success) {
            this.$message.success('删除成功')
            await this.loadData()
          } else {
            this.$message.error(message)
          }
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    async handleSpuSubmit() {
      this.$refs.spuForm.validate(async valid => {
        if (valid) {
          this.spuSubmitLoading = true
          try {
            const url = this.spuForm.id ? `/spu/${this.spuForm.id}` : '/spu'
            const method = this.spuForm.id ? 'put' : 'post'
            const res = await this.$http[method](url, this.spuForm)
            let success = false
            let message = '操作失败'
            if (res.code === '200' || res.code === 200) {
              success = true
            } else if (res.data && (res.data.code === '200' || res.data.code === 200)) {
              success = true
            }
            if (res.message) message = res.message
            if (res.data && res.data.message) message = res.data.message
            
            if (success) {
              this.$message.success('操作成功')
              this.spuDialogVisible = false
              await this.loadData()
            } else {
              this.$message.error(message)
            }
          } catch (error) {
            this.$message.error('操作失败')
          } finally {
            this.spuSubmitLoading = false
          }
        }
      })
    },
    handleManageSku(row) {
      const spuName = row.product ? row.product.productName : `${row.color}-${row.size}`
      this.$router.push({
        name: 'Sku',
        query: { spuId: row.spuId, spuName: spuName }
      })
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.query.pageNum = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
